import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import { DeleteDialog } from 'common/components/deleteDialog/DeleteDialog';
import { DeleteDialogCustomField } from 'common/components/deleteDialog/DeleteDialogCustomField';
import { selectPageInfo, setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { useDeleteDialogHandler } from 'common/hooks/useDeleteDialogHandler';
import { deleteUserRoleMembership } from 'common/services/api/UserRoleMemberships/UserRoleMemberships.thunk';
import { DeleteDialogContentProps } from 'common/types/TypeDefs';

export function UserRoleMembershipsDeleteDialog({
    customDeleteTitle,
    itemId,
    editingRow
}: Readonly<DeleteDialogContentProps<{ roleName: string, roleId: string }>>) {
    const dispatch = useAppDispatch();
    const pageInfo = useAppSelector(selectPageInfo);
    const { roleName, roleId } = editingRow ?? {};
    const userFirstName = pageInfo?.firstName ?? 'Unknown';
    const userLastName = pageInfo?.lastName ?? 'User';
    const { tenantId } = useParams();

    const { processing, handleDelete } = useDeleteDialogHandler({
        deleteThunk: deleteUserRoleMembership,
        entityName: 'User from this Role',
        successMessage: 'Role has been removed from this User under this Tenant.',
        onSuccess: (result) => {
            dispatch(setRows(result.formattedData));
        },
    });

    const deleteCallback = () => {
        if (itemId) {
            handleDelete({
                tenantId: tenantId ?? '',
                userId: pageInfo?.userId ?? '',
                roleId: roleId ?? ''
            });
        }
    };

    return (
        <DeleteDialog deleteCallback={deleteCallback} processing={processing} customDeleteTitle={`${customDeleteTitle}`}>
            <DeleteDialogCustomField fieldName='User' fieldValue={`${userFirstName} ${userLastName}`}/>
            <DeleteDialogCustomField fieldName='Role Name' fieldValue={roleName}/>
            <DeleteDialogCustomField fieldName='Tenant Name' fieldValue={pageInfo?.name ?? ''}/>
        </DeleteDialog>
    );
}
